// extracted by mini-css-extract-plugin
export default {"cardContent":"f847a4776a6e","heading":"a76d1802e33d","statusBadge":"eae84ed7bcdd"};